const ko_KR = {
  "colorpicker.opacity-input": "불투명",
  "datepicker.clear-date": "완료일",
  "datepicker.next-month": "다음 달",
  "datepicker.open-calendar": "캘린더 열기",
  "datepicker.previous-month": "지난달",
  "input.clear": "입력 지우기",
  "input.hide-password": "비밀번호 숨기기",
  "input.show-password": "비밀번호 표시",
  "modal.close": "닫기",
  "multiselectchips.add-value": "' {value} ' 추가",
  "multiselectchips.remove-all": "모두 제거",
  "pagination.next-page": "다음 페이지",
  "pagination.previous-page": "이전 페이지"
};
export {
  ko_KR as default
};
//# sourceMappingURL=ko_KR.json.js.map
